// @ts-nocheck
import { defineComponent, computed } from 'vue';
import type { PropType } from 'vue';
import type { SVGJson, TreeObj } from '../utils/use-render';
import { renderFn, formatColor } from '../utils/use-render';
import { useNamespace } from '@nio-fe/shared';
import '../style/index.scss';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"currentColor","d":"M17.96 8.71l-6.72 6.72c-.29.3-.77.3-1.06 0L7 12.25a1.5 1.5 0 012.12 0l1.6 1.59 5.12-5.13a1.5 1.5 0 012.12 0z"}},{"tag":"path","attrs":{"fill":"currentColor","d":"M12 20.5a8.5 8.5 0 110-17 8.5 8.5 0 010 17zm0 1.5a10 10 0 100-20 10 10 0 000 20z"}}]};

export default defineComponent({
  name: 'IconComplete',
  props: {
    color: {
      type: [Array, String] as PropType<string[] | string>,
      required: false,
      default: () => [],
    },
    spin: {
      type: String as PropType<'cw' | 'ccw'>,
      required: false,
    },
    size: {
      type: [String, Number],
      required: false,
      // default: 24,
    },
    rotate: {
      type: Number,
      required: false,
    },
  },
  emits: {
    click: (evt: MouseEvent) => evt instanceof MouseEvent,
  },
  setup(props, { attrs, emit }) {
    return () => {
      const { size, color, spin, rotate } = props;
      const prefix = `${useNamespace()}-icon`.toLowerCase();

      const spinClassName = `${spin ? `${prefix}_spin-${spin}` : ''}`;
      const iconStyle = computed(() => ({
        fontSize: size,
        transform: `rotate(${rotate}deg)`,
        ...(attrs.style as StyleSheet),
      }));
      const finalColor = computed(() => formatColor(color));
      const finalClass = computed(() => [prefix, `${prefix}__complete`, spinClassName, attrs.class]);
      const finalProps = {
        class: finalClass.value,
        style: iconStyle.value,
        onClick: (evt: MouseEvent) => emit('click', evt),
      };

      return renderFn(element, finalProps, finalColor.value as TreeObj);
    };
  },
});
